export const isExpanderVisible = ({ contentHeight, maxHeight }: { contentHeight: number; maxHeight: number }) => {
  return contentHeight > maxHeight;
};
